import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyBfeWV2dzDL69PydGqLN9gopGnzO3xN0GM",
    authDomain: "kreo-seace.firebaseapp.com",
    projectId: "kreo-seace",
    storageBucket: "kreo-seace.firebasestorage.app",
    messagingSenderId: "45247605835",
    appId: "1:45247605835:web:7ff473a52613739d9b71ce"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);
